import { RepairPreference } from '../declarations';

import keyMirror from 'keymirror';

export const BINSR_TYPE = 'rs_brn_initial';

export const REPAIR_PREFERENCES: { [K in RepairPreference]: K } = keyMirror({
  credit_preferred: true,
  none_requested: true,
  repairs_preferred: true,
});

export const humanizedRepairPreferences: { [K in RepairPreference]: string } = {
  credit_preferred: 'Credit in lieu of repairs',
  none_requested: 'No repairs or credit requested',
  repairs_preferred: 'Repairs',
};
